const invertedMessages = {
  Sort: 'CERTS_SORT',
  Clear: 'CERTS_CLEAR',
};

export default invertedMessages;
